import { observer } from 'mobx-react-lite';
import React from 'react';
import { TabPanel } from 'react-tabs';
import { colors } from '../../../../../../../../colorVars';
import { updatePlugins } from '../../../../../../../../stores/websocketStore/utils/outgoingMessages/tradePlan/updateTradePlanMessages/updatePlugins';
import { useWebsocketStore } from '../../../../../../../../stores/websocketStore/websocketProvider';
import { EditableTableField } from '../../../../../../../atomic/inputs/editableTableField/EditableTableField';
import { Body3 } from '../../../../../../../atomic/text/Text';
import { IndividualPanelHeader } from '../IndividualPanelHeader';
import style from '../IndividualTacticStyle.module.css';

export const MarketOrderTacticPanel = observer(
  // eslint-disable-next-line no-unused-vars
  ({ tradePlanId, addTab, ...rest }) => {
    const { tradePlanStore } = useWebsocketStore();
    const tradePlan = tradePlanStore.tradePlans[tradePlanId];
    const { quantityBasis, inPosition } = tradePlan;
    const updateMarketOrder = (newValue) => {
      updatePlugins(
        'tactic',
        { quantityBasisValue: newValue },
        'MARKET_ORDER',
        tradePlanId,
        null
      );
    };
    if (!tradePlan) return null; 
    return (
      <TabPanel {...rest}>
        <div className={style.tableContainer}>
          <table className={style.table}>
            <IndividualPanelHeader />
            <tbody>
              <tr>
                <td className={style.labelTd}>
                  <Body3 fontWeight={700} color={colors.lightGrey}>
                    {quantityBasis === 'DOLLARS'
                      ? 'Dollar Amount'
                      : 'Qty. Amount'}
                  </Body3>
                </td>
                <td className={style.inputTd}>
                  <Body3
                    fontWeight={700}
                    color={colors.lightGrey}
                    margin="3px 3px 0 0"
                  >
                    {quantityBasis === 'DOLLARS' ? '$' : '#'}
                  </Body3>
                  <EditableTableField
                    color={colors.lightGrey}
                    bodySize={3}
                    backgroundColor={colors.black}
                    disabled={inPosition}
                    initialValue={
                      tradePlan.entryTactics['MARKET_ORDER'].quantityBasisValue
                    }
                    updateValue={(newValue) => {
                      if (newValue !== 0 && newValue !== tradePlan.entryTactics['MARKET_ORDER'].quantityBasisValue) updateMarketOrder(newValue);
                    }}
                    inputType="number"
                  />
                </td>
                <td></td>
                <td></td>
              </tr>
            </tbody>
          </table>
        </div>
      </TabPanel>
    );
  }
);
MarketOrderTacticPanel.tabsRole = 'TabPanel';
